import React from 'react';

import { PageLayout } from '@thinknet-gmbh/platform-common-ui';
import { TasksWidget } from './components/tasks-widget';

const Dashboard: React.FC = () => (
  <PageLayout pageTitle="Main Dashboard">
    <TasksWidget />
  </PageLayout>
);

export default Dashboard;
